import * as React from "react";
import styled from "@emotion/styled";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

interface IProps {
    publishDate: string | null;
    lastUpdateDate: string;
    showBorders?: boolean;
}

export const TimeStamp: React.FC<IProps> = (props) => {
    const {showBorders = true} = props;

    return (
        <TimeStampHolder variant="body_copy_2" as="div" showBorders={showBorders}>
            {props.publishDate && <div css={mb(2)}>Data publikacji: {formatDate(props.publishDate, dateTimeFormat.shortDate)}</div>}
            <div>Data aktualizacji: {formatDate(props.lastUpdateDate, dateTimeFormat.shortDate)}</div>
        </TimeStampHolder>
    );
};

interface IThemeProps {
    showBorders?: boolean;
}

const TimeStampHolder = styled(Text)<IThemeProps>`
    color: ${(props) => props.theme.colors.gray[700]};
    padding: 1.6rem 0;
    border-top: 1px solid ${(props) => props.theme.colors.gray[300]};
    border-bottom: 1px solid ${(props) => props.theme.colors.gray[300]};
    border-top-width: ${(props) => (props.showBorders ? "1px" : 0)};
    border-bottom-width: ${(props) => (props.showBorders ? "1px" : 0)};
`;
import * as React from "react";
import styled from "@emotion/styled";

import {mb} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {dateTimeFormat, formatDate} from "@pg-mono/string-utils";

interface IProps {
    publishDate: string | null;
    lastUpdateDate: string;
    showBorders?: boolean;
}

export const TimeStamp: React.FC<IProps> = (props) => {
    const {showBorders = true} = props;

    return (
        <TimeStampHolder variant="body_copy_2" as="div" showBorders={showBorders}>
            {props.publishDate && <div css={mb(2)}>Data publikacji: {formatDate(props.publishDate, dateTimeFormat.shortDate)}</div>}
            <div>Data aktualizacji: {formatDate(props.lastUpdateDate, dateTimeFormat.shortDate)}</div>
        </TimeStampHolder>
    );
};

interface IThemeProps {
    showBorders?: boolean;
}

const TimeStampHolder = styled(Text)<IThemeProps>`
    color: ${(props) => props.theme.colors.gray[700]};
    padding: 1.6rem 0;
    border-top: 1px solid ${(props) => props.theme.colors.gray[300]};
    border-bottom: 1px solid ${(props) => props.theme.colors.gray[300]};
    border-top-width: ${(props) => (props.showBorders ? "1px" : 0)};
    border-bottom-width: ${(props) => (props.showBorders ? "1px" : 0)};
`;
